<div class="row">
	<div class="col-lg-1 mt-4">
		<h2>Rates Report</h2>
	</div>
	<div class="col-lg-2 mt-4">
		<button pButton class="btn-addt p-button ml-2" (click)="runQualityTestAllProperty()">Re-Run Quality Report</button>
	</div>
</div>
<p-menu #cm [model]="menuItems" [popup]="true" > </p-menu>
<ag-grid-angular 
	style="width: 100%; height: 400px;"
	class="ag-theme-balham rates-report-table"
	[rowData]="gridData"
	[gridOptions]="gridOptions"
	(gridReady)="onGridReady($event)"
	[columnDefs]="columnDefs"
	(firstDataRendered)="onFirstDataRendered($event)"
	[groupDefaultExpanded]="groupDefaultExpanded"
	(rowGroupOpened)="onRowGroupOpened($event)"
	(rowClicked)="onRowClicked($event)"
	(cellClicked)="onCellClicked($event)">

</ag-grid-angular>
